export const getColumnHeaderConfigurationFrom = (dataRows) => {
  return dataRows.find((r) => r.isHeadingCell === true);
};
